import React, { useEffect, useState } from "react";
import classes from "./SideMenu.module.scss";
import exportIcon from "./../../static/images/export-icon.svg";
import menuLine from "../../static/images/menu-line.png";
import cancelImage from "../../static/images/cancel-icon.png";
import lockIcon from "../../static/images/lock-icon-white.svg";
import { useAtom } from "jotai";
import { sideMenuAtom } from "../../state/side-menu/SideMenuAtom";
import UserInfo from "../user-info/UserInfo";
import { useNavigate } from "react-router-dom";
import { logout } from "../../api/LogoutApi";
import { login, loginCheck } from "../../api/LoginApi";

const SideMenu = () => {
  const navigate = useNavigate();
  const logoutApi = logout();
  const loginApi = login();
  const loginCheckApi = loginCheck();

  useEffect(() => {
    if (logoutApi.state?.status === "success") {
      // ログアウトが完了してから画面遷移
      loginApi.reset();
      loginCheckApi.reset();
      transit("/login");
      logoutApi.reset(); // 状態リセット（連打対策）
    }
  }, [logoutApi.state]);

  const transit = (url: string) => {
    setState({
      ...state,
      isShow: false,
    });
    navigate(url);
  };

  const menuList = [
    {
      name: "お問い合わせ",
      onclick: () =>
        window.open(
          "https://form.run/@miraii-concierge-contact",
          "_blank",
          "noopener,noreferrer"
        ),
      display: true,
      isButtomLine: true,
      icon: exportIcon,
    },
    {
      name: "ログアウト",
      isLock: false,
      display: true,
      onclick: () => {
        logoutApi.post();
      },
    },
  ];

  const [state, setState] = useAtom(sideMenuAtom);

  const cancel = () => {
    setState({
      ...state,
      isShow: false,
    });
  };

  const addStyle = (isButtomLine?: boolean) => {
    return isButtomLine
      ? {
          borderBottom: "1rem solid rgb(255 255 255 / 35%)",
          paddingBottom: "24rem",
        }
      : {};
  };

  return (
    <div className={classes.container}>
      <div className={classes.headerArea}>
        <img
          src={cancelImage}
          alt={cancelImage}
          className={classes.cancelImage}
          onClick={cancel}
        />
      </div>
      <div className={classes.userInfo}>
        <UserInfo userName={state.userName} userEmail={state.userEmail} />
      </div>
      <div className={classes.menuListContainer}>
        <div className={classes.lineImageContainer}>
          <img src={menuLine} alt="menuLine" className={classes.lineImage} />
        </div>
        <div className={classes.menuList}>
          {menuList
            .filter((m) => m.display)
            .map((menu, index) => (
              <>
                {menu.isLock ? (
                  <div
                    key={index}
                    className={`${classes.name} ${classes.lock}`}
                    style={addStyle(menu.isButtomLine)}
                  >
                    <img src={lockIcon} alt={lockIcon} />
                    {menu.name}
                  </div>
                ) : (
                  <div
                    key={index}
                    className={classes.name}
                    style={addStyle(menu.isButtomLine)}
                    onClick={menu.onclick}
                  >
                    {menu.name}
                    {menu.icon && (
                      <img
                        src={menu.icon}
                        alt={menu.icon}
                        className={classes.icon}
                      />
                    )}
                  </div>
                )}
              </>
            ))}
        </div>
      </div>
    </div>
  );
};

export default SideMenu;
